import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
export default function Portal(_ref) {
  var children = _ref.children,
      containerElement = _ref.container;
  var container = useRef(containerElement);
  var portal = useRef(document.createElement('div'));
  useEffect(function () {
    if (!container.current) {
      container.current = document.body;
    }

    var portalContainer = portal.current;
    container.current.appendChild(portalContainer);
    return function () {
      if (container.current) {
        container.current.removeChild(portalContainer);
      }
    };
  }, []);
  return portal.current ? /*#__PURE__*/createPortal(children, portal.current) : null;
}